export default __webpack_public_path__ + "static/media/mn350action.1d50b6fe.png";